<template>
  <div class="promo-design-group">
    <div class="promo-timer-setting">
      <div class="div-flex-layout">
        <v-text-field
          v-model.trim="actions.rf_settings_close_seconds"
          class="mb-4"
          variant="outlined"
          density="compact"
          persistentPlaceholder
          label="Auto close in seconds"
          name="close-seconds"
          hideDetails
          placeholder="e.g.: 20"
          bgColor="#ffffff"
        ></v-text-field>
        <v-text-field
          v-if="
            (model.path_type === 'retention_modal' ||
              model.path_type === 'video' ||
              (model.path_type === 'interstitial' &&
                !['ios', 'android_os', 'android_tv'].includes(model.device_type)) ||
              model.path_type === 'widget') &&
            !hideAutoCloseText
          "
          v-model.trim="
            (currentTranslations.hasOwnProperty('rf_settings_close_seconds_text')
              ? previewActions
              : actions
            ).rf_settings_close_seconds_text
          "
          class="mb-4"
          variant="outlined"
          density="compact"
          persistentPlaceholder
          label="Auto close text"
          :disabled="currentTranslations.hasOwnProperty('rf_settings_close_seconds_text')"
          name="close-seconds"
          hideDetails
          placeholder="e.g.: 20"
          bgColor="#ffffff"
        ></v-text-field>
      </div>
      <div class="div-flex-layout">
        <v-text-field
          v-if="!displayOff"
          v-model.trim="actions.rf_settings_timer_font_size"
          variant="outlined"
          density="compact"
          label="Timer font size"
          persistentPlaceholder
          name="close-seconds"
          hideDetails
          placeholder="e.g.: 14px"
          bgColor="#ffffff"
        ></v-text-field>
        <v-text-field
          v-if="!displayOff"
          v-model.trim="actions.rf_settings_timer_font_color"
          variant="outlined"
          density="compact"
          persistentPlaceholder
          label="Timer font color"
          name="close-seconds"
          hideDetails
          placeholder="e.g.: #ffffff"
          bgColor="#ffffff"
          @blur="
            actions.rf_settings_timer_font_color = extendHex(actions.rf_settings_timer_font_color)
          "
        ></v-text-field>
      </div>
      <RfPromoInteractionInterval
        v-if="actions.rf_settings_close_seconds"
        interactionType="timeout"
        :action="actions.rf_settings_timeout_interval"
        @setIntervalAction="setIntervalAction"
      />
      <div v-if="model.path_type !== 'text'" class="div-flex-layout" style="margin-bottom: 15px">
        <v-checkbox
          v-model="actions.rf_settings_hide_timer_text"
          label="Hide timer text"
          trueValue="true"
          falseValue="false"
          hideDetails
        />
      </div>
    </div>
  </div>
</template>
<script>
import RfPromoInteractionInterval from "@/components/RfPromotions/RfPromoInteractionInterval.vue";
import { extendHex } from "@/utils/colorHelpers";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";

export default {
  name: "RfRetentionActionsBehavior",
  components: { RfPromoInteractionInterval },
  mixins: [LanguagePreviewMixin],
  props: {
    actions: { type: Object, default: () => ({}) },
    model: { type: Object, default: () => ({}) },
    displayOff: { type: Boolean, default: false },
    hideAutoCloseText: { type: Boolean, default: false },
  },
  setup: () => ({ extendHex }),
  methods: {
    setIntervalAction(value, type) {
      this.actions[`rf_settings_${type}_interval`] = value;
    },
  },
};
</script>

<style>
.countdown-text-div {
  padding: 0 0 10px 0;
  font-weight: 500;
}
.promo-timer-setting {
  display: flex;
  flex-direction: row;
}
.promo-timer-setting > div.v-input {
  flex: 1;
  padding-right: 16px;
}
.promo-timer-setting > div.v-input:last-child {
  flex: 1;
  padding-right: 0px;
}
</style>
